export enum EmailFieldErrorsEnum {
  INVALID_LENGTH = 'E-mail inválido, limite de caracteres excedido',
  INVALID_EMAIL = 'E-mail inválido',
  REQUIRED_FIELD = 'Campo obrigatório',
  INVALID_TOAST = 'O e-mail inserido não é válido. Verifique e tente novamente.',
  ALREADY_REGISTERED = 'E-mail já cadastrado. Faça login na sua conta',
  REQUIRED_TOAST_FORGOT_PASSWORD = 'Insira seu e-mail',
}
